import {useParams} from 'react-router-dom';

import useUser from "../../hooks/useUser";
import AppDashboard from "../AppDashboard";
import AppointmentSuccessScreen from "../../components/scheduling/AppointmentSuccessScreen";
import LoadingScreen from '../../components/common/LoadingScreen';
import { useGetAppointmentsQuery } from "../../redux/services/appointmentApi";

const AppointmentSuccessPage = props => {
  const {id} = useParams();
  const user = useUser();
  const appointmentQuery = useGetAppointmentsQuery({id}, {skip: !id});
  if (!user) return <LoadingScreen/>;
  const isProvider = user?.is_provider;
  return (
    <AppDashboard loading={appointmentQuery.isLoading}>
      <AppointmentSuccessScreen
        appointment={appointmentQuery?.data?.data?.[0] || null}
        isProvider={isProvider}
        showHomeBtn
      />
    </AppDashboard>  
  );
};

export default AppointmentSuccessPage;